export class ProjectsUsersRoutePaths {
    static removeUserFromProject = 'roles/remove';

    static projectUsers(projectId: string) {
        return `users/inProject/${projectId}`;
    }
}
